<template>
  <woot-modal :show.sync="show" :on-close="onClose" :size="modalSize">
    <woot-modal-header
      :header-title="$t('MESSENGER_TEMPLATES.MODAL.TITLE')"
      :header-content="modalHeaderContent"
    />
    <div v-if="hasMessengerTemplates" class="row modal-content">
      <templates-picker
        v-if="!selectedMessengerTemplate"
        :messenger-template-messages="messengerTemplateMessages"
        @onSelect="pickTemplate"
      />
      <template-parser
        v-else
        :template="selectedMessengerTemplate"
        @resetTemplate="onResetTemplate"
        @sendMessage="onSendMessage"
      />
    </div>
  </woot-modal>
</template>

<script>
import TemplatesPicker from './TemplatesPicker.vue';
import TemplateParser from './TemplateParser.vue';
export default {
  components: {
    TemplatesPicker,
    TemplateParser,
  },
  props: {
    inboxId: {
      type: Number,
      default: undefined,
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectedMessengerTemplate: null,
    };
  },
  computed: {
    messengerTemplateMessages() {
      // getMessengerTemplates ya filtra aprobadas (backend, Channel::FacebookPage#sync_templates) y
      // los formatos de media no soportados; se reusa directamente para evitar doble filtrado.
      return this.$store.getters['inboxes/getMessengerTemplates'](this.inboxId);
    },
    hasMessengerTemplates() {
      return this.messengerTemplateMessages.length > 0;
    },
    // Devuelve el tamaño del modal según si hay plantillas de Messenger disponibles o no.
    modalSize() {
      return this.hasMessengerTemplates ? 'modal-big' : 'modal-medium';
    },
    modalHeaderContent() {
      if (this.selectedMessengerTemplate) {
        return this.$t('MESSENGER_TEMPLATES.MODAL.TEMPLATE_SELECTED_SUBTITLE', {
          templateName: this.selectedMessengerTemplate.name,
        });
      }
      if (this.hasMessengerTemplates) {
        return this.$t('MESSENGER_TEMPLATES.MODAL.SUBTITLE');
      }
      return this.$t('MESSENGER_TEMPLATES.MODAL.NO_TEMPLATES_SUBTITLE');
    },
  },
  methods: {
    pickTemplate(template) {
      this.selectedMessengerTemplate = template;
    },
    onResetTemplate() {
      this.selectedMessengerTemplate = null;
    },
    onSendMessage(message) {
      this.$emit('on-send', message);
    },
    onClose() {
      this.$emit('cancel');
    },
  },
};
</script>

<style scoped>
.modal-content {
  padding: 2.5rem 3.2rem;
}
</style>
